import { useState } from 'react';
import type { AvatarProps } from './Avatar.types';
import './Avatar.scss';

const initials = (name?: string): string => {
  if (!name) return '?';
  const parts = name.trim().split(/\s+/).slice(0, 2);
  return parts.map(p => p.charAt(0).toUpperCase()).join('') || '?';
};

export default function Avatar({ name, src, size = 'md', alt, className }: AvatarProps) {
  const [failed, setFailed] = useState(false);
  const showImage = src && !failed;
  return (
    <span
      className={['avatar', `avatar--${size}`, className || ''].filter(Boolean).join(' ')}
      role="img"
      aria-label={alt || name || 'Аватар'}
    >
      {showImage ? (
        <img
          src={src}
          alt={alt || name || ''}
          className="avatar__img"
          onError={() => setFailed(true)}
        />
      ) : (
        <span className="avatar__initials">{initials(name)}</span>
      )}
    </span>
  );
}
